import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { NotFoundComponent } from './modules/not-found/not-found.component';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: 'home' },


    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,

        resolve: {
            initialData: initialDataResolver
        },
        children: [
            { path: 'verify', loadComponent: () => import('app/modules/auth/confirmation-required/confirmation-required.component').then(comp => comp.AuthConfirmationRequiredComponent) },
            { path: 'forgot-password', loadComponent: () => import('app/modules/auth/forgot-password/forgot-password.component').then(comp => comp.AuthForgotPasswordComponent) },
            { path: 'reset', loadComponent: () => import('app/modules/auth/reset-password/reset-password.component').then(comp => comp.AuthResetPasswordComponent) },
            { path: 'sign-in', loadComponent: () => import('app/modules/auth/sign-in/sign-in.component').then(comp => comp.AuthSignInComponent) },
            { path: 'sign-up', loadComponent: () => import('app/modules/auth/sign-up/sign-up.component').then(comp => comp.AuthSignUpComponent) },
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            { path: 'sign-out', loadComponent: () => import('app/modules/auth/sign-out/sign-out.component').then(comp => comp.AuthSignOutComponent) },
            //{path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/')}
        ]
    },

    {
        path: '',
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            { path: 'terms-and-conditions', loadComponent: () => import('app/modules/terms-and-conditions/terms-and-conditions.component').then(comp => comp.TermsAndConditionsComponent) },
            {
                path: 'contact-us', loadComponent: () => import('app/modules/landing/contact-us/contact-us.component').then(comp => comp.ContactUsComponent),

            },
            // {
            //     path: 'blogs',
            //     children: [
            //         {
            //             path: '',
            //             loadComponent: () =>
            //                 import('app/modules/landing/blogs/blogs.component')
            //                     .then((comp) => comp.BlogsPage),
            //         },
            //         {
            //             path: ':id',
            //             loadComponent: () =>
            //                 import('app/modules/landing/blogs/viewBlog/viewBlog.component')
            //                     .then((comp) => comp.ViewBlog),
            //         }
            //     ]
            // },
            {
                path: 'contact-us/complaints', loadComponent: () => import('app/modules/landing/contact-us/complaints/complaints.component').then(comp => comp.ComplaintsComponent),

            },
            {
                path: 'about-us', loadComponent: () => import('app/modules/landing/about-us/about-us.component').then(comp => comp.AboutUsComponent),

            },
            // {path: 'faq', loadComponent: () => import('app/modules/faq/faq.component').then(comp => comp.FaqComponent)},
            {
                path: 'product-overview', loadChildren: () => import('app/modules/landing/catalog/catalog.routes'),

            },
            { path: 'products', loadChildren: () => import('app/modules/landing/products/products.routes') },
            {
                path: 'support', loadComponent: () => import('app/modules/support/support.component').then(comp => comp.SupportComponent),
            },
            //{path: 'network', loadChildren: () => import('app/modules/network-status/network-status.routes')},
    
            { path: 'pre-orders', loadComponent: () => import('app/modules/sales-agent/sales-agent.component').then(comp => comp.SalesAgentComponent) },
            {
                path: 'home', loadComponent: () => import('app/modules/landing/home/home.component').then(comp => comp.LandingHomeComponent),
            },
            { path: 'packages', loadComponent: () => import('app/modules/order-process/packages/packages.component').then(comp => comp.PackagesComponent)},
            { path: 'cart', loadComponent: () => import('app/modules/order-process/cart/cart.component').then(comp => comp.CartComponent)},
            { path: 'confirm-order', loadComponent: () => import('app/modules/order-process/confirm-order/confirm-order.component').then(comp => comp.ConfirmOrderComponent)},
            { path: 'deals', loadComponent: () => import('app/modules/landing/deals/deals.component').then(comp => comp.DealsComponent)},
        ]
    },

    // Admin routes
    {
        path: '',
        canActivate: [AuthGuard],
        // canActivateChild: [AuthGuard],
 
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            // {path: 'example', loadChildren: () => import('app/modules/admin/example/example.routes')},
            { path: 'dashboard', loadComponent: () => import('app/modules/dashboard/dashboard.component').then(comp => comp.DashboardComponent) },
            {path: 'dashboard/services', loadComponent: () => import('app/modules/dashboard/services-list/services-list.component').then(comp => comp.ServicesListComponent)},
            // {path: 'dashboard/tickets', loadComponent: () => import('app/modules/dashboard/tickets/tickets.routes')},
            // {path: 'dashboard/payment-method', loadComponent: () => import('app/modules/shared-components/payment-method/payment-methods.routes')},
            { path: 'dashboard/profile', loadComponent: () => import('app/modules/dashboard/profile/profile.component').then(comp => comp.ProfileComponent) },
            // {path: 'dashboard/invoiceStatements', loadComponent: () => import('app/modules/dashboard/invoice-statements/invoice-statements.routes')},
            { path: 'dashboard/requests', loadComponent: () => import('app/modules/dashboard/requests/requests.component').then(comp => comp.RequestsComponent) },
            { path: 'dashboard/invoices', loadComponent: () => import('app/modules/dashboard/invoices/invoices.component').then(comp => comp.InvoicesComponent) },
            { path: 'dashboard/campaign', loadComponent: () => import('app/modules/campaign/campaign.component').then(comp => comp.CampaignComponent) },
            { path: 'dashboard/balances', loadComponent: () => import('app/modules/dashboard/balances/balances.component').then(comp => comp.BalancesComponent) },
         
        ]
    },



    // 404
    { path: '**', pathMatch: 'full', component: NotFoundComponent },
]